import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-content">
          <Link to="/">
            <img
              src="/images/logo-blanc.png"
              alt="THE RECAP Logo"
              className="footer-logo"
            />
          </Link>

          <div className="footer-links-section">
            <div className="footer-contact">
              <p className="footer-label">Contact :</p>
              <a href="mailto:hello@the-recap.events" className="footer-email">
                hello@the-recap.events
              </a>
            </div>

            <div className="footer-legal">
              <Link to="/mentions-legales" className="footer-link">
                Mentions Légales
              </Link>
            </div>
          </div>

          <p className="footer-copyright">
            © 2026 THE RECAP
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
